import classNames from "classnames";
import styles from "./ShowInfo.module.css";

//#region [Props]
type ShowInfoProps = {
    info?: string | null;
    className?: string;
};
//#endregion

//#region [Component]
export default function ShowInfo({ info, className }: ShowInfoProps) {
    if (!info) {
        return null;
    }
    return <p className={classNames(styles.ShowInfo, className)}>{info}</p>;
}
//#endregion
